import React from "react";
import dayjs from "dayjs";
import Button from "../Buttons/Button";

const ModalData = ({ selectedUser, selectedDate }) => {
  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">
        Time Entries for {selectedUser?.name}
      </h2>
      <div className="grid grid-cols-[8fr_2fr] gap-10">
        <div className="grid grid-cols-7 gap-2 select-none">
          {/* Calendar header */}
          {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day) => (
            <div key={day} className="text-center font-medium p-2 bg-gray-100">
              {day}
            </div>
          ))}

          {/* Calendar days */}
          {(() => {
            const monthStart = selectedDate.startOf("month");
            const startDate = monthStart.subtract(monthStart.day() - 1, "day");
            const monthEnd = selectedDate.endOf("month");
            const endDate = monthEnd.add(7 - monthEnd.day(), "day");
            const calendarDays = [];

            let day = startDate;
            while (day.isSameOrBefore(endDate)) {
              const workDetail = selectedUser?.workDetails.find(
                (work) =>
                  dayjs(work.date).format("DD-MM-YYYY") ===
                  day.format("DD-MM-YYYY")
              );

              calendarDays.push(
                <div
                  key={day.format("YYYY-MM-DD")}
                  className={`select-none p-2 border h-[60px] flex flex-col items-center justify-center gap-1 ${
                    !day.isSame(selectedDate, "month") ? "bg-gray-50" : ""
                  } ${
                    day.day() === 0 || day.day() === 6 ? "bg-neutrals-100" : ""
                  }`}
                >
                  <div className="text-[10px]">{day.format("DD/MMM")}</div>
                  <div className="text-sm font-medium">
                    {workDetail ? workDetail.working : "--"}
                  </div>
                </div>
              );

              day = day.add(1, "day");
            }

            return calendarDays;
          })()}
        </div>
        <div>
          <div className="flex flex-col gap-4">
            <Button
              title="Approve Selected Timesheets"
              color="black"
              className="!justify-start !bg-success-100 !border-success-100 !text-black"
              size="sm"
            />
            <Button
              title="Reject Selected Timesheets"
              color="black"
              className="!justify-start  !bg-danger-100 !border-danger-100 !text-black"
              size="sm"
            />
            <Button
              title="Reset Selected Timesheets"
              color="black"
              className="!justify-start  !bg-draft-100 !border-draft-100 !text-black"
              size="sm"
            />
            <Button
              title="Mark as Invoiced"
              color="black"
              className="!justify-start  !bg-invoiced-100 !border-invoiced-100 "
              size="sm"
            />
            <Button
              title="Download Attachments"
              color="black"
              className="!justify-start  !bg-gray-500 !border-gray-500 "
              size="sm"
            />
            <Button
              title="Export Selected Timesheets"
              color="black"
              className="!justify-start"
              size="sm"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalData;